module.exports = __webpack_public_path__ + "img/screen-manual-17.70ffd4f2.png";